var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('title-name'),_c('template-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }